import FeatureController from '../FeatureController';

export default class QuestionsController extends FeatureController
{
    constructor (panel, $state) {
        super(panel, $state);
        const self = this;
        this.qa = {
            PENDING: null,  // questions are pending answers
            ANSWERED: 1,    // questions have been answered
            LATER: 2        // will answer questions later
        };
        this.isQuestionnaire = false;
        this.age_range = this.panel.range(18, 100);
        this.type = $state.params.type;
        this.info = $state.params.type;
        this.context = {};
        this.profile = {};
        this.match = {};

        this.chemistry = {};
        this.match_vars = ['body_type', 'eye_color', 'eye_color'];
        this.panel.setTitle('Answer Questions - '+this.type.toUpperCase());
        this.panel.get('/v1/questions/'+$state.params.type, (response) => {
            if (self.panel.okay(response)) {
                for (let i in response.data) {
                    self[i] = response.data[i];
                }

                if (self.type === 'match') {
                    if (!self.match.status) {
                        self.match = {
                            status: self.options.status[0].id,
                            min_height: self.options.height[0].id,
                            max_height: self.options.height[self.options.height.length - 1].id,
                            min_age: self.age_range[0],
                            max_age: self.age_range[self.age_range.length - 1]
                        };
                    } else {
                        let except = ['status'];
                        for (let i in self.options) {
                            if (self.match[i] && except.indexOf(i) === -1) {
                                self.match[i] = self.match[i].split(',');
                            }
                        }
                    }
                }
            }
        });
        for (let i in this.options) {
            if (!this.profile[i] && this.options[i].length > 0) {
                this.profile[i] = this.options[i][0]['id'];
            }
        }
    }

    checkFields (data) {
        let test = this.context[this.info];
        if(!test) return true;
        let bad = [];
        this.error_message = '';
        $('.input-error').removeClass('input-error');
        if(test){
            for(let j in test){
                let i = test[j];
                typeof data[i.parameter] != 'undefined' && (data[i.parameter] == '' || data[i.parameter] == null) && parseInt(i.required) == 1 && bad.push(i.parameter);
            }
        }
        if(bad.length > 0){
            this.error_message = "Please complete the mandatory fields in red";
            $('.'+this.info).find('.'+bad.join(',.')).addClass('input-error');
            $(window).scrollTop(0);
            return false;
        }
        return true;
    }

    validated () {
        switch(this.type){
            case 'basic':
                this.postData = this.profile;
                return this.checkFields(this.profile);
            case 'match':
                this.postData = this.match;
                return this.checkFields(this.match);
            case 'chemistry':
                this.postData = this.chemistry;
                return true;
        }
    }

    markAnswered (question) {
        $('.question-'+question.id).removeClass('missed').addClass('answered');
        $('.question-'+question.id+' .fa-check').removeClass('hide');
    }

    next (state) {
        if (this.isQuestionnaire){
            let missed = false;
            for(let i in this.chemistry){
                if(typeof this.chemistry[i].answer == 'undefined'){
                    missed = true;
                    $('.question-'+this.chemistry[i]['id']).addClass('missed');
                }

            }
            if(missed && typeof state == 'undefined'){
                this.panel.alert("Please answer all red questions.");
                return;
            }
        }

        if (this.validated()) {
            let data = {type:this.type, questions:this.postData};
            typeof state != 'undefined' && (data.state = state);
            const self = this;
            this.panel.post(this.post_url, data, (response) => {
                if (self.panel.okay(response)){
                    location.href = response.redirect;
                }
            });
        }
    }

    get_checked_match (k, v) {
        return this.match[k] && this.match[k].indexOf(v+"") > -1;
    }

    push_match (k, v) {
        if (!this.match[k]) {
            this.match[k] = [];
        }
        this.match[k].indexOf(v) > -1 && this.match[k].splice(this.match[k].indexOf(v),1) || this.match[k].push(v);
    }
}



// WEBPACK FOOTER //
// ./src/app/features/questions/QuestionsController.js